export default __webpack_public_path__ + "static/media/logo-white.7f6f4fb1.svg";